module.exports = __webpack_public_path__ + "static/img/loader.ede41570.svg";